import React, { useState, Fragment } from "react"
import { Button, Grid, Container } from "@material-ui/core"
import { VPaquetesStyle } from "./styles"
import FPaquetes from "./../FPaquetes"
import FPaquetesGaleria from "../FPaquetesGaleria"
import FPaquetesVuelos from "../FPaquetesVuelos"
import FPaquetesExtras from "../FPaquetesExtras"
import FPaquetesHoteles from "../FPaquetesHoteles"
import FPaquetesHabitaciones from "../FPaquetesHabitaciones"
import FPaquetesSalidas from "../FPaquetesSalidas"
import FPaquetesDestinos from "../FPaquetesDetinos"
import TPaquetes from "./../TPaquetes"
import { useSelector } from "react-redux"
import Landing from "../Landing"
import LandingPaquete from "../LandingPaquete"
import FBusqueda from "../../../global/FBusqueda"

export default function VPaquetes() {
  const classes = VPaquetesStyle()
  const paquetes = useSelector((store) => store.paquetes.array)
  const [openModal, setOpenModal] = useState(false)
  const [rowTarget, setRowTarget] = useState({ IdPaquete: 0 })
  const [editar, setEditar] = useState(false)
  const [openModalVuelos, setOpenModalVuelos] = useState(false)
  const [openModalExtras, setOpenModalExtras] = useState(false)
  const [openModalHotel, setOpenModalHotel] = useState(false)
  const [openModalHabitacion, setOpenModalHabitacion] = useState(false)
  const [openModalSalidas, setOpenModalSalidas] = useState(false)
  const [openModalGaleria, setOpenModalGaleria] = useState(false)
  const [openModalDestinos, setOpenModalDestinos] = useState(false)



  const handleOpen = () => {
    setOpenModal(!openModal);
    setEditar(false);
  }
  const handleOpenDestinos = (rowTarget) => {
    setRowTarget(rowTarget);
    setOpenModalDestinos(!openModalDestinos);
    setEditar(false);
  }
  const handleOpenGaleria = (rowTarget) => {
    setRowTarget(rowTarget);
    setOpenModalGaleria(!openModalGaleria);
    setEditar(false);
  }
  const handleOpenSalidas = (rowTarget) => {
    setRowTarget(rowTarget);
    setEditar(false);
    setOpenModalSalidas(!openModalSalidas);
  }
  const handleOpenHabitacion = (rowTarget) => {
    setRowTarget(rowTarget);
    setEditar(false);
    setOpenModalHabitacion(!openModalHabitacion);
  }
  const handleOpenExtras = (rowTarget) => {
    setRowTarget(rowTarget);
    setEditar(false);
    setOpenModalExtras(!openModalExtras);
  }
  const handleOpenVuelos = (rowTarget) => {
    setRowTarget(rowTarget);
    setEditar(false);
    setOpenModalVuelos(!openModalVuelos);
  }
  const handleOpenHoteles = (rowTarget) => {
    setRowTarget(rowTarget);
    setEditar(false);
    setOpenModalHotel(!openModalHotel);
  }
  const onEditar = (rowTarget) => {
    setRowTarget(rowTarget);
    setOpenModal(!openModal);
    setEditar(true);
  }
  return (
    <Fragment>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.contentMargin}
        >
          <Grid item xs={3}>
            <FBusqueda />
          </Grid>
          <Grid item xs={4} className={classes.flexEnd} >
            <Button variant="outlined" color="primary" onClick={handleOpen}>Nuevo Paquete</Button>
            <Landing />
          </Grid>
          <Grid item xs={12}>
            <TPaquetes
              rows={paquetes}
              onEditar={onEditar}
              onVuelos={handleOpenVuelos}
              onExtras={handleOpenExtras}
              onHotel={handleOpenHoteles}
              onHabitacion={handleOpenHabitacion}
              onSalidas={handleOpenSalidas}
              onGaleria={handleOpenGaleria}
              onDestinos={handleOpenDestinos}
            />
          </Grid>
        </Grid>
      </Container>
      <FPaquetes
        open={openModal}
        setOpen={setOpenModal}
        editar={editar}
        rowData={rowTarget}
        setEditar={setEditar}
      />
      <FPaquetesVuelos
        open={openModalVuelos}
        setOpen={setOpenModalVuelos}
        rowData={rowTarget}
      />
      <FPaquetesExtras
        open={openModalExtras}
        setOpen={setOpenModalExtras}
        rowData={rowTarget}
      />
      <FPaquetesHoteles
        open={openModalHotel}
        setOpen={setOpenModalHotel}
        rowData={rowTarget}
      />
      <FPaquetesHabitaciones
        open={openModalHabitacion}
        setOpen={setOpenModalHabitacion}
        rowData={rowTarget}
      />
      <FPaquetesSalidas
        open={openModalSalidas}
        setOpen={setOpenModalSalidas}
        rowData={rowTarget}
      />
      <FPaquetesGaleria
        open={openModalGaleria}
        setOpen={setOpenModalGaleria}
        rowData={rowTarget}
      />
      <FPaquetesDestinos
        open={openModalDestinos}
        setOpen={setOpenModalDestinos}
        rowData={rowTarget}
      />
      <LandingPaquete />
    </Fragment>
  )
}
